import { action } from '@ember/object';
import SettingsDepartmentsBaseController from '../base';

export default class SettingsDepartmentsListCreateController extends SettingsDepartmentsBaseController {
  @action
  cancel() {
    // Delete the record instead of just rolling back
    this.model.destroyRecord();
    this.goToListPage();
  }
}
